import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, error, hint, className = '', id, ...rest },
  ref
) {
  return (
    <label className="block w-full">
      {label && <span className="mb-1.5 block text-sm font-medium text-ink-700">{label}</span>}
      <input
        ref={ref}
        id={id}
        className={[
          'h-[50px] w-full rounded-xl border bg-surface px-4 text-[15px] text-ink-800',
          'placeholder:text-ink-400 transition-colors duration-200',
          'focus:outline-none focus:ring-2 focus:ring-brand-200 focus:border-brand-400',
          error ? 'border-critical' : 'border-ink-200',
          className,
        ].join(' ')}
        {...rest}
      />
      {error ? (
        <span className="mt-1 block text-xs text-critical">{error}</span>
      ) : hint ? (
        <span className="mt-1 block text-xs text-ink-400">{hint}</span>
      ) : null}
    </label>
  );
});
